import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';

import { userEntitiesSelector, presenceEntitiesSelector } from 'selectors/entity';
import { user as userSchema } from 'schemas/user';

const getUser = (state, _user) => _user;

export const getUserByIdSelector = createSelector(
    getUser,
    userEntitiesSelector,
    presenceEntitiesSelector,
    (_user, userEntities, presenceEntities) => {
        const users = denormalize(
            [_user],
            [userSchema],
            { users: userEntities, presences: presenceEntities }
        );

        return users && users[0] ? users[0] : null;
    }
);
